import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setIsLoading } from "../slices/reportSlice";
import * as services from "../services/reportApi";
import { generateRandomString } from "utils/helper";
import * as slices from "../slices/reportSlice"
import { setReportTableSalary } from "../slices/reportSlice";
import { getEmployeeStatusTypeOptions, getEmploymentTypeOptions } from "features/masterData/services/optionsApi";
import useOptions from "features/masterData/hooks/useOptions";
import { useTranslation } from "react-i18next";

function useSalaryCalculationGroup() {
    const { t, i18n } = useTranslation();
    const [showReport, setShowReport] = useState(false);
    const dispatch = useDispatch();
    const reportTableSalary = useSelector((state) => state.report.reportTableList || []);
    const [departmentListOption, setDepartmentListOption] = useState([]);
    const currentCompany = useSelector((state) => state.company.currentCompany);
    const [pagination, setPagination] = useState({ page: 0, currentPage: 0, size: 10 });
    const [search, setSearch] = useState({});

    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };

    const modifiedDepartmentOption = useMemo(() => {
        const modifiedOptions = departmentListOption?.map((opt) => ({
            ...opt,
            value: opt?.id,
            label: i18n.language === "en" ? opt?.nameEn : opt?.name,
        }));

        return modifiedOptions;
    }, [i18n.language, departmentListOption]);

    const getReportTableSalary = useCallback(
        async (params = {}) => {
            try {
                dispatch(setIsLoading(true));
                const response = await services.getReportTableSalary({
                    requestId: generateRandomString(),
                    companyId: currentCompany,
                    ...params,
                    page: 0,
                    size: 10

                });

                console.log("Response data:", response?.data?.page?.content);
                dispatch(setReportTableSalary(response?.data?.page?.content));
            } catch (error) {
                console.error("Error fetching report history:", error);
            } finally {
                dispatch(setIsLoading(false));
            }
        },
        [dispatch, reportTableSalary]
    );

    const getDepartment = useCallback(async () => {
        if (!currentCompany) return null;
        try {
            dispatch(setIsLoading(true));
            const response = await services.getDepartmentOptions({
                requestId: generateRandomString(),
                companyId: currentCompany,
            });
            dispatch(setDepartmentListOption(response.data));
        } catch (error) {
            // alert({ type: "error", resultObject: error });
        } finally {
            dispatch(setIsLoading(false));
        }
    }, [currentCompany, dispatch]);

    const handleSearch = (values) => {
        setShowReport(true)
        setSearch({})
        setSearch({ ...values })
        getReportTableSalary({ ...values, ...pagination })
    };

    useEffect(() => {

        if (currentCompany) {
            getDepartment();

        }
    }, [currentCompany]);

    return {
        showReport,
        handleSearch,
        departmentOptions: modifiedDepartmentOption,
        reportTableSalary,
        getReportTableSalary,
        isModalOpen,
        setIsModalOpen,
        showModal
    }
}
export default useSalaryCalculationGroup;